export const KENDO_TEMPLATE_DIRECTIVES = new Map<string, string>([
    ["kendoAutoCompleteFooterTemplate", "footerTemplate"],
    ["kendoAutoCompleteHeaderTemplate", "headerTemplate"],
    ["kendoAutoCompleteItemTemplate", "itemTemplate"],
    ["kendoAutoCompleteNoDataTemplate", "noDataTemplate"],
    ["kendoCalendarCellTemplate", "cellTemplate"],
    ["kendoCalendarCenturyCellTemplate", "centuryCellTemplate"],
    ["kendoCalendarDecadeCellTemplate", "decadeCellTemplate"],
    ["kendoCalendarMonthCellTemplate", "monthCellTemplate"],
    ["kendoCalendarWeekNumberCellTemplate", "weekNumberCellTemplate"],
    ["kendoCalendarYearCellTemplate", "yearCellTemplate"],
    ["kendoDropDownListFooterTemplate", "footerTemplate"],
    ["kendoDropDownListHeaderTemplate", "headerTemplate"],
    ["kendoDropDownListItemTemplate", "itemTemplate"],
    ["kendoDropDownListNoDataTemplate", "noDataTemplate"],
    ["kendoDropDownListValueTemplate", "valueTemplate"],
    ["kendoMultiSelectListFooterTemplate", "footerTemplate"],
    ["kendoMultiSelectDropDownListHeaderTemplate", "headerTemplate"],
    ["kendoMultiSelectDropDownListItemTemplate", "itemTemplate"],
    ["kendoMultiSelectDropDownListNoDataTemplate", "noDataTemplate"],
    ["kendoMultiSelectDropDownListValueTemplate", "valueTemplate"],
    ["kendoUploadFileTemplate", "fileTemplate"]
]);